import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchContent } from "../redux/actions/contentActions";

const AboutUs = () => {
  const dispatch = useDispatch();

  // Access content state from Redux
  const { loading, data, error } = useSelector((state) => state.content);

  useEffect(() => {
    dispatch(fetchContent("about_us"));
  }, [dispatch]);

  return (
    <div className="container min-h-[60vh]">
      <div>
        <p className="text-medium-theme-color mt-4 text-xl lg:text-3xl font-semibold">
          About Us
        </p>
      </div>

      <div className="my-4 flex flex-col gap-2 text-base lg:text-lg">
        {loading && <p>Loading content...</p>}

        {error && (
          <p className="text-red-600 font-semibold">
            {error || "Failed to load About Us content."}
          </p>
        )}

        {!loading && !error && data?.description && (
          // <p>{data.description}</p>
          <div dangerouslySetInnerHTML={{ __html: data.description }} />
        )}
      </div>
    </div>
  );
};

export default AboutUs;
